import React, { useEffect, useState } from "react";
import styles from "../Public.module.scss";
import {
  CustomTextInput as TextField,
  InputType,
} from "../components/CustomTextInput";
import { useNavigate, useLocation } from "react-router-dom";
import { useValidation, validators } from "../../../hooks/useValidation";
import { useFetch, Methods } from "../../../hooks/useFetch";
import { useGlobalState } from "../../../context/GlobalStateContext";

const RestartPassword: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [forgotPasswordToken, setForgotPasswordToken] = useState<string | null>(
    () => {
      if (location && location.search) {
        const tokenSplit = location.search.split("=");
        if (tokenSplit.length) {
          return tokenSplit[1];
        }
      }
      return null;
    }
  );

  interface User {
    newPassword: string;
    confirmPassword: string;
    forgotPasswordToken: string;
  }

  const validationConfig = {
    newPassword: [validators.isNull, validators.isEmpty],
    confirmPassword: [validators.isNull, validators.isEmpty],
    forgotPasswordToken: [],
  };

  const { error } = useGlobalState();

  const {
    values: user,
    errors,
    handleChange,
    validateForm,
  } = useValidation(
    {
      newPassword: "",
      confirmPassword: "",
      forgotPasswordToken: forgotPasswordToken,
    },
    validationConfig
  );

  const { makeRequest: restartPassword, loading } = useFetch<User>(
    `/api/restart_password`,
    {
      method: Methods.POST,
      body: user,
    }
  );

  const handleRestartPassword = async () => {
    if (validateForm()) {
      const { data: response } = await restartPassword();

      if (response && response.error === null) {
        navigate("/login");
      }
    }
  };

  useEffect(() => {}, []);

  return (
    <div className={styles.wrapperContent}>
      <div className={styles.container}>
        <div className={styles.backgroundImage}>
          <div className={styles.overlay}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/logo@2x.png`}
              alt="BetBook Logo"
              className={styles.logo}
              onClick={() => navigate("/")}
            />
            <div className={styles.overlayContent}>
              <TextField
                name="newPassword"
                label="Password"
                placeholder="Password"
                type={InputType.Password}
                value={user.newPassword}
                error={Boolean(errors.newPassword) || Boolean(error)}
                errorMessage={errors.newPassword || error}
                onChange={handleChange}
              />
              <TextField
                name="confirmPassword"
                label="Confirm Password"
                placeholder="Confirm Password"
                type={InputType.Password}
                value={user.confirmPassword}
                error={Boolean(errors.confirmPassword) || Boolean(error)}
                errorMessage={errors.confirmPassword || error}
                onChange={handleChange}
              />
            </div>
            <div className={styles.overlayButtons}>
              <button
                className={styles.createAccount}
                onClick={handleRestartPassword}
                disabled={
                  loading ||
                  Object.keys(errors).some((error) => errors[error] !== null)
                }
              >
                Set new password
              </button>
              <button
                className={styles.alreadyAccount}
                onClick={() => navigate("/login")}
              >
                I already have an account
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestartPassword;
